module.exports = __webpack_public_path__ + "static/media/General_Diagram.8f316511.jpg";